import { Component } from '@angular/core';
import { TranslationsService } from '../services/translations/translations.service';
import { CookiebotService } from '../services/cookiebot/cookiebot.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cookiebot',
  templateUrl: './cookiebot.component.html',
  styleUrls: ['./cookiebot.component.scss']
})
export class CookiebotComponent {
  lang: string = "en";
  constructor(private trans: TranslationsService, private cookieService: CookiebotService, private activeRoute: ActivatedRoute,) { 
    
    this.trans.lang.subscribe((lg)=>{
      this.lang=lg as string;
    });
    this.trans.getLang(this.activeRoute.paramMap);
  }
  ngAfterViewInit(){
    this.cookieService.loadCookiebot(this.lang);

  }
}